"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OctopusFeatureClient = void 0;
var axios_1 = __importDefault(require("axios"));
var axios_retry_1 = __importDefault(require("axios-retry"));
var octopusFeatureContext_1 = require("./octopusFeatureContext");
var web_sdk_1 = require("@openfeature/web-sdk");
var OctopusFeatureClient = /** @class */ (function () {
    function OctopusFeatureClient(configuration) {
        var _this = this;
        var _a;
        this.localStorageKey = "octopus-openfeature-ts-feature-manifest";
        this.clientIdentifier = configuration.clientIdentifier;
        this.serverUri = configuration.serverUri ? configuration.serverUri.replace(/\/$/, "") : "https://features.octopus.com";
        this.logger = (_a = configuration.logger) !== null && _a !== void 0 ? _a : new web_sdk_1.DefaultLogger();
        this.axiosInstance = axios_1.default.create();
        (0, axios_retry_1.default)(this.axiosInstance, {
            retries: 3,
            onRetry: function (retryCount, error) {
                return _this.logger.warn("Failed to retrieve feature toggles ".concat(retryCount, " time(s) for client identifier ").concat(_this.clientIdentifier, " from ").concat(_this.serverUri, " with error: \n ").concat(JSON.stringify(error)));
            },
        });
    }
    OctopusFeatureClient.prototype.getEvaluationContext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var manifest, rawCache, cacheEntry_1, cacheEntry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFeatureManifest()];
                    case 1:
                        manifest = _a.sent();
                        if (manifest === undefined) {
                            rawCache = localStorage.getItem(this.localStorageKey);
                            if (rawCache === null) {
                                return [2 /*return*/, new octopusFeatureContext_1.OctopusFeatureContext({ evaluations: [], contentHash: "" })];
                            }
                            try {
                                cacheEntry_1 = JSON.parse(rawCache);
                                if (this.isV1CacheEntry(cacheEntry_1)) {
                                    return [2 /*return*/, new octopusFeatureContext_1.OctopusFeatureContext(cacheEntry_1.contents)];
                                }
                            }
                            catch (e) {
                                this.logger.warn("An error occurred parsing feature toggles returned from Octopus: ".concat(JSON.stringify(e)));
                            }
                            return [2 /*return*/, new octopusFeatureContext_1.OctopusFeatureContext({ evaluations: [], contentHash: "" })];
                        }
                        cacheEntry = { schemaVersion: "v1", contents: manifest };
                        localStorage.setItem(this.localStorageKey, JSON.stringify(cacheEntry));
                        return [2 /*return*/, new octopusFeatureContext_1.OctopusFeatureContext(manifest)];
                }
            });
        });
    };
    OctopusFeatureClient.prototype.isV1CacheEntry = function (entry) {
        var possibleV1CacheEntry = entry;
        return (possibleV1CacheEntry.schemaVersion === "v1" &&
            possibleV1CacheEntry.contents !== undefined &&
            possibleV1CacheEntry.contents.evaluations !== undefined &&
            possibleV1CacheEntry.contents.contentHash !== undefined);
    };
    OctopusFeatureClient.prototype.getFeatureManifest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenSegments, isV3ClientIdentifier, config, response, contentHash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenSegments = this.clientIdentifier.split(".");
                        isV3ClientIdentifier = tokenSegments.length === 3;
                        config = isV3ClientIdentifier
                            ? {
                                url: "".concat(this.serverUri, "/api/featuretoggles/v3/"),
                                maxContentLength: Infinity,
                                maxBodyLength: Infinity,
                                method: "GET",
                                responseType: "json",
                                headers: {
                                    Authorization: "Bearer ".concat(this.clientIdentifier),
                                },
                            }
                            : {
                                url: "".concat(this.serverUri, "/api/featuretoggles/v2/").concat(this.clientIdentifier),
                                maxContentLength: Infinity,
                                maxBodyLength: Infinity,
                                method: "GET",
                                responseType: "json",
                            };
                        return [4 /*yield*/, this.axiosInstance.request(config)];
                    case 1:
                        response = _a.sent();
                        if (response.status == 404) {
                            this.logger.warn("Failed to retrieve feature toggles for client identifier ".concat(this.clientIdentifier, " from ").concat(this.serverUri));
                            return [2 /*return*/, undefined];
                        }
                        contentHash = response.headers.get("ContentHash");
                        if (!contentHash) {
                            this.logger.warn("Feature toggle response from ".concat(this.serverUri, " did not contain expected ContentHash header."));
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, { evaluations: response.data, contentHash: contentHash }];
                }
            });
        });
    };
    return OctopusFeatureClient;
}());
exports.OctopusFeatureClient = OctopusFeatureClient;
